import request from '@/utils/request'

export function getList(params) {
  params = {...params, 'order[kilter]': 'asc'}
  return request({
    url: '/api/desks',
    method: 'get',
    params
  })
}

export function getOne(id) {
  return request({
    url: `/api/desks/${id}`,
    method: 'get'
  })
}

export function post(data) {
  return request({
    url: '/api/desks',
    method: 'post',
    data
  })
}


export function deleteDesk(id) {
  return request({
    url: `/api/desks/${id}`,
    method: 'delete'
  })
}

export function put(id, data) {
  return request({
    url: `/api/desks/${id}`,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/modules/settings/components/Tables/api.js